import { useEffect } from 'react';
import { useFormV2 } from '@abyss/web/hooks/useForm';
import { AlertService } from '@src/api/common/AlertService';
import {
  GridDefaultColumns,
  IGridBuilderProps,
} from '@src/components/global/GridBuilder/interfaces/IGridBuilderProps';
import { AlertVariantType } from '@src/constants/AlertVariantType';
import { ApiStatus } from '@src/constants/ApiStatus';
import { UrlService } from '@src/api/common/UrlService';
import { FollowUpStatusService } from '@src/api/web-services/features/admin/FollowUpStatusService';
import { PageTitleService } from '@src/api/common/PageTitleService';
import { BreadcrumbService } from '@src/api/common/BreadcrumbService';
import { Breadcrumbs, Title } from './PageInfo';

export const FollowUpStatusGridController = () => {
  const { AlertModel, ShowAlert } = AlertService();
  const { GetAll } = FollowUpStatusService();
  const { UpdatePageTitle } = PageTitleService();
  const { UpdateBreadcrumb } = BreadcrumbService();

  const form = useFormV2({
    defaultValues: {
      name: '',
    },
  });

  const DataSource = {
    GridApiMethod: async () => {
      const body = form.getValues();
      const apiData = await GetAll(body);
      if (apiData.status === ApiStatus.Success && apiData.data?.results) {
        const response = apiData.data.results;
        return response;
      }
      AlertModel.variant = AlertVariantType.ERROR;
      AlertModel.message = apiData.message
        ? apiData.message
        : apiData.data.message;
      AlertModel.visible = true;
      AlertModel.isPermanent = true;
      await ShowAlert(AlertModel);

      return [];
    },
  };

  const gridProps: IGridBuilderProps = {
    gridName: 'follow-up-status-grid',
    columns: [
      {
        field: 'id',
        heading: '',
        width: 45,
        disableSort: true,
        link: {
          url: `/admin/follow-up-status/detail/`,
          showValue: false,
          appendValueInUrl: true,
          icon: 'edit',
        },
      },
      { field: 'name', heading: 'Name', width: 200 },
      {
        field: 'isActive',
        heading: 'Active',
        width: 200,
      },
      GridDefaultColumns.CreatedDate,
      GridDefaultColumns.CreatedBy,
      GridDefaultColumns.UpdatedDate,
      GridDefaultColumns.UpdatedBy,
    ],
    gridHeading: 'Follow Up Status',
    gridOptionName: 'follow-up-status-grid-options',
    gridApiMethod: DataSource.GridApiMethod,
    form,
    createNewButton: {
      text: 'Create New',
      url: `/admin/follow-up-status/detail/0`,
    },
  };

  const Action = {
    InIt: async () => {
      await UpdatePageTitle(Title);
      await UpdateBreadcrumb(Breadcrumbs);
    },
  };

  useEffect(() => {
    Action.InIt();
  }, []);

  return { form, gridProps };
};
